/// <amd-module name="SearchUI/Helpers/SearchResultsComponentHelper" />
import * as  React from "react";
import { Link } from "VSSUI/Link";

import "VSS/LoaderPlugins/Css!SearchUI/Helpers/SearchResultsComponentHelper";

export function getTitleComponent(titleLinkUrl: string, titleComponent: JSX.Element, ariaLabel?: string, onFileNameClicked?: (link: string, evt: React.MouseEvent<HTMLAnchorElement> | React.KeyboardEvent<HTMLAnchorElement>) => void): JSX.Element {
    return (<Link
        target={"_blank"}
        className={"search-result-title-link"}
        rel={"noopener noreferrer"}
        href={titleLinkUrl}
        onClick={onFileNameClicked ? evt => onFileNameClicked(titleLinkUrl, evt) : undefined}
        aria-label={ariaLabel}>
        {titleComponent}
    </Link>);
}
